import script from "./EditWidgetPopup.vue?vue&type=script&lang=js"
export * from "./EditWidgetPopup.vue?vue&type=script&lang=js"

import "./EditWidgetPopup.vue?vue&type=style&index=0&id=37c6def2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c6def2"],['__file',"src/containers/widget/EditWidgetPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37c6def2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37c6def2', __exports__)) {
    api.reload('37c6def2', __exports__)
  }
  
}


export default __exports__